export enum ShortPathTypeEnum {
  Car = 'CAR',
  Cepik = 'CEPIK',
  Cepik3 = 'CEPIK_3',
  NoMatch = 'NO_MATCH',
  NoRequiredDataProvided = 'NO_REQUIRED_DATA_PROVIDED',
  Quotation = 'QUOTATION',
}
